var _ellipse, _ellipse2, _ellipse3, _ellipse4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _line, _line2, _line3, _line4, _line5, _line6, _path8, _path9, _path10, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _path11, _path12, _path13, _rect, _rect2, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _path14, _path15, _path16, _rect3, _rect4, _ellipse23, _ellipse24, _ellipse25, _ellipse26, _ellipse27, _ellipse28, _ellipse29, _ellipse30, _ellipse31, _ellipse32, _ellipse33, _ellipse34, _ellipse35, _ellipse36, _ellipse37, _ellipse38, _path17, _path18, _path19, _rect5, _rect6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvoice1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 279,
    height: 291,
    viewBox: "0 0 279 291",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 176,
    cy: 208.188,
    rx: 103,
    ry: 71.5,
    fill: "#EFEFEF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 126.5,
    cy: 212.688,
    rx: 126.5,
    ry: 78,
    fill: "url(#paint0_linear_0_1)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 122.5,
    cy: 190.188,
    rx: 111.5,
    ry: 67.5,
    fill: "#F9FAFB"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 118.5,
    cy: 184.188,
    rx: 107.5,
    ry: 66.5,
    fill: "#EBEBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M153.5 216.5L156 218L154.75 217.25L158 219C159.167 219 166 221.5 166.5 214.187V81.6874C166.667 76.8541 169 67.1874 177 67.1874C178.5 67.5207 181.5 70.1874 181.5 78.1874V103.687C181.667 106.854 184.5 111.787 194.5 106.187C199.167 103.354 208.1 93.7874 206.5 78.1874C206.333 75.1874 206.5 69.5 211.5 66.5C216.5 63.5 221.5 59.2874 221.5 73.6874C221.5 73.6874 221.5 73.9997 226 71.5C230.5 69.0003 221.5 56.3123 210 51C198.5 45.6877 133.5 5.68773 133.5 5.68773C130.333 4.18773 123.1 3.08773 119.5 10.6877L98 40.6875L102 186.688L153.5 216.5Z",
    stroke: "#3B33C1",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M160.5 209.187C160.5 220.787 156.833 220.02 155 218.187L77 171.188C71.8 168.387 70.1667 162.021 70 159.188V28.6871C75.2 3.88712 88.5 4.68712 94.5 8.18712L178 60.6875C162 61.8875 160.5 75.5205 160.5 82.6871V209.187Z",
    fill: "#F3F2FF",
    stroke: "#6C63FF",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M178.5 64.188L117.5 21.6878L110 15.688L115.5 8.68759C123.5 -2.81159 131 0.187489 136 2.68749L218.5 50.5C218.5 50.5 227 55 229 59.5C229.423 60.452 231.5 62 231 70C231 74.5 223.5 76.688 223.5 76.688C223.5 53.6736 201.5 65.5 203 76.688C204.5 87.8759 202.5 90.688 202 92.188C196.5 105 183.5 110.5 184.5 101V77.6878C184.1 66.0878 179.5 65.688 178.5 64.188Z",
    fill: "#6C63FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M179.897 109.253V83.8021V82.2468C180.425 73.1223 178.797 70.1498 177.918 69.8041C171.847 68.5598 170.11 77.5808 170 82.2468V99.8739L179.897 109.253Z",
    fill: "#D6D4F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M132 129.296V110.745C132 109.972 132.839 109.491 133.505 109.882L150.505 119.841C150.812 120.02 151 120.349 151 120.704V139.255C151 140.028 150.161 140.509 149.495 140.118L132.495 130.159C132.188 129.98 132 129.651 132 129.296Z",
    fill: "#6C63FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M132 161.87V141L151 152.13V173L132 161.87Z",
    fill: "#6C63FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M132 191.87V171L151 182.13V203L132 191.87Z",
    fill: "#6C63FF"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 83.4317,
    y1: 36.1494,
    x2: 152.149,
    y2: 77.5683,
    stroke: "#6C63FF",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 83.4317,
    y1: 55.1494,
    x2: 152.149,
    y2: 96.5683,
    stroke: "#6C63FF",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 81.445,
    y1: 75.205,
    x2: 125.205,
    y2: 102.555,
    stroke: "#6C63FF",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 85.4269,
    y1: 99.1305,
    x2: 123.13,
    y2: 121.573,
    stroke: "#6C63FF",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 83.4241,
    y1: 127.12,
    x2: 123.12,
    y2: 150.576,
    stroke: "#6C63FF",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 84.4178,
    y1: 153.095,
    x2: 123.095,
    y2: 175.582,
    stroke: "#6C63FF",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M138 123.864L141.484 130L150 121",
    stroke: "#F3F2FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M138 155.864L141.484 162L150 153",
    stroke: "#F3F2FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M138 185.864L141.484 192L150 183",
    stroke: "#F3F2FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62,
    cy: 187,
    rx: 23,
    ry: 17,
    fill: "#FFD06C"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62,
    cy: 184.5,
    rx: 23,
    ry: 14.5,
    fill: "#F9A83D"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62,
    cy: 180,
    rx: 23,
    ry: 17,
    fill: "#FFD06C"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62,
    cy: 177.5,
    rx: 23,
    ry: 14.5,
    fill: "#F9A83D"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62,
    cy: 173,
    rx: 23,
    ry: 17,
    fill: "#FFD06C"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62,
    cy: 170.5,
    rx: 23,
    ry: 14.5,
    fill: "#F9A83D"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62,
    cy: 166,
    rx: 23,
    ry: 17,
    fill: "#FFD06C"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62,
    cy: 163.5,
    rx: 23,
    ry: 14.5,
    fill: "#F9A83D"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62,
    cy: 159,
    rx: 23,
    ry: 17,
    fill: "#FFD06C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5 155.5C83.5 158.807 81.3706 162.021 77.4635 164.484C73.5759 166.935 68.1127 168.5 62 168.5C55.8873 168.5 50.4241 166.935 46.5365 164.484C42.6294 162.021 40.5 158.807 40.5 155.5C40.5 152.193 42.6294 148.979 46.5365 146.516C50.4241 144.065 55.8873 142.5 62 142.5C68.1127 142.5 73.5759 144.065 77.4635 146.516C81.3706 148.979 83.5 152.193 83.5 155.5Z",
    fill: "#FFD06C",
    stroke: "#F9A83D",
    strokeWidth: 3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M61 162.5C64.8333 162.167 71.9 160.6 69.5 157C68.8333 156.5 66.4 155.8 62 157C60 157.834 55.6 158.9 54 156.5C53.1667 155.167 53.4 152.3 61 151.5",
    stroke: "#F9A83D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 152L71 162.5",
    stroke: "#F9A83D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 60,
    y: 144,
    width: 12,
    height: 26,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 51,
    y: 143,
    width: 6,
    height: 27,
    fill: "white"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 101,
    cy: 216,
    rx: 23,
    ry: 17,
    fill: "#FFD06C"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 101,
    cy: 213.5,
    rx: 23,
    ry: 14.5,
    fill: "#F9A83D"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 101,
    cy: 209,
    rx: 23,
    ry: 17,
    fill: "#FFD06C"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 101,
    cy: 206.5,
    rx: 23,
    ry: 14.5,
    fill: "#F9A83D"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 101,
    cy: 202,
    rx: 23,
    ry: 17,
    fill: "#FFD06C"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 101,
    cy: 199.5,
    rx: 23,
    ry: 14.5,
    fill: "#F9A83D"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 101,
    cy: 195,
    rx: 23,
    ry: 17,
    fill: "#FFD06C"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 101,
    cy: 192.5,
    rx: 23,
    ry: 14.5,
    fill: "#F9A83D"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 101,
    cy: 188,
    rx: 23,
    ry: 17,
    fill: "#FFD06C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M122.5 184.5C122.5 187.807 120.371 191.021 116.464 193.484C112.576 195.935 107.113 197.5 101 197.5C94.8873 197.5 89.4241 195.935 85.5365 193.484C81.6294 191.021 79.5 187.807 79.5 184.5C79.5 181.193 81.6294 177.979 85.5365 175.516C89.4241 173.065 94.8873 171.5 101 171.5C107.113 171.5 112.576 173.065 116.464 175.516C120.371 177.979 122.5 181.193 122.5 184.5Z",
    fill: "#FFD06C",
    stroke: "#F9A83D",
    strokeWidth: 3
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M100 191.5C103.833 191.167 110.9 189.6 108.5 186C107.833 185.5 105.4 184.8 101 186C99 186.834 94.6 187.9 93 185.5C92.1667 184.167 92.4 181.3 100 180.5",
    stroke: "#F9A83D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5 181L110 191.5",
    stroke: "#F9A83D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 99,
    y: 172,
    width: 12,
    height: 25,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 90,
    y: 171,
    width: 6,
    height: 26,
    fill: "white"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 191,
    cy: 162.5,
    rx: 23,
    ry: 14.5,
    fill: "#F9A83D"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 191,
    cy: 158,
    rx: 23,
    ry: 17,
    fill: "#FFD06C"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 191,
    cy: 155.5,
    rx: 23,
    ry: 14.5,
    fill: "#F9A83D"
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 191,
    cy: 151,
    rx: 23,
    ry: 17,
    fill: "#FFD06C"
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 191,
    cy: 148.5,
    rx: 23,
    ry: 14.5,
    fill: "#F9A83D"
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 191,
    cy: 144,
    rx: 23,
    ry: 17,
    fill: "#FFD06C"
  })), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 191,
    cy: 141.5,
    rx: 23,
    ry: 14.5,
    fill: "#F9A83D"
  })), _ellipse30 || (_ellipse30 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 191,
    cy: 137,
    rx: 23,
    ry: 17,
    fill: "#FFD06C"
  })), _ellipse31 || (_ellipse31 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 191,
    cy: 134.5,
    rx: 23,
    ry: 14.5,
    fill: "#F9A83D"
  })), _ellipse32 || (_ellipse32 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 191,
    cy: 130,
    rx: 23,
    ry: 17,
    fill: "#FFD06C"
  })), _ellipse33 || (_ellipse33 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 191,
    cy: 127.5,
    rx: 23,
    ry: 14.5,
    fill: "#F9A83D"
  })), _ellipse34 || (_ellipse34 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 191,
    cy: 123,
    rx: 23,
    ry: 17,
    fill: "#FFD06C"
  })), _ellipse35 || (_ellipse35 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 191,
    cy: 120.5,
    rx: 23,
    ry: 14.5,
    fill: "#F9A83D"
  })), _ellipse36 || (_ellipse36 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 191,
    cy: 116,
    rx: 23,
    ry: 17,
    fill: "#FFD06C"
  })), _ellipse37 || (_ellipse37 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 191,
    cy: 113.5,
    rx: 23,
    ry: 14.5,
    fill: "#F9A83D"
  })), _ellipse38 || (_ellipse38 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 191,
    cy: 109,
    rx: 23,
    ry: 17,
    fill: "#FFD06C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M212.5 105.5C212.5 108.807 210.371 112.021 206.464 114.484C202.576 116.935 197.113 118.5 191 118.5C184.887 118.5 179.424 116.935 175.536 114.484C171.629 112.021 169.5 108.807 169.5 105.5C169.5 102.193 171.629 98.979 175.536 96.5158C179.424 94.065 184.887 92.5 191 92.5C197.113 92.5 202.576 94.065 206.464 96.5158C210.371 98.979 212.5 102.193 212.5 105.5Z",
    fill: "#FFD06C",
    stroke: "#F9A83D",
    strokeWidth: 3
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M190 112.5C193.833 112.167 200.9 110.6 198.5 107C197.833 106.5 195.4 105.8 191 107C189 107.834 184.6 108.9 183 106.5C182.167 105.167 182.4 102.3 190 101.5",
    stroke: "#F9A83D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M181.5 102L200 112.5",
    stroke: "#F9A83D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 189,
    y: 93,
    width: 12,
    height: 25,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 180,
    y: 92,
    width: 6,
    height: 26,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 253,
    y1: 206.187,
    x2: 11.5,
    y2: 206.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F4F4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice1);
export default __webpack_public_path__ + "static/media/Invoice1.de9bd90e706e912e46f485cc84430df6.svg";
export { ForwardRef as ReactComponent };